import { createFileRoute } from "@tanstack/react-router";
import { PermissionGate } from "@/shared/auth/PermissionGate";
import { tienePermisoEnSesion } from "@/shared/auth/permiso-en-sesion";
import { PERMISOS } from "@/lib/permisos";
import { ErrorAlert } from "@/components/ui";
import { AdminNotificacionesPage } from "@/features/admin-notificaciones/components/AdminNotificacionesPage";
import {
  catalogoNotificacionesQueryOptions,
  flujosQueryOptions,
} from "@/features/admin-notificaciones/hooks/use-notificaciones";

/** Ruta `/admin/notificaciones` · flujos de notificaciones y bitácora de envíos. */
export const Route = createFileRoute("/_authed-tw/admin/notificaciones/")({
  loader: ({ context: { queryClient } }) =>
    tienePermisoEnSesion([PERMISOS.adminNotificaciones])
      ? Promise.all([
      queryClient.ensureQueryData(catalogoNotificacionesQueryOptions),
      queryClient.ensureQueryData(flujosQueryOptions({ page: 1, pageSize: 15 })),
    ])
      : undefined,
  component: () => (
    <PermissionGate permisos={[PERMISOS.adminNotificaciones]}>
      <AdminNotificacionesPage />
    </PermissionGate>
  ),
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
